import { handleAction, combineActions } from 'redux-actions';
import { timeDay, timeMonth, timeYear } from 'd3-time';
import { timeParse } from 'd3-time-format';

import { selectActivityAction } from '../actions/activity';
import { loginAction, logoutAction } from '../actions/authentication';
import { setViewDatesAction } from '../actions/time';
import { viewUpdatedAction } from '../actions/view';
import { defaultErrorHandler } from './errors';

const htmlDateParse = timeParse('%Y-%m-%d');
const htmlMonthParse = timeParse('%Y-%m');
const htmlYearParse = timeParse('%Y');

const getSearchParam = (key) => {
  const query = window.location.search.substring(1);
  const vars = query.split('&');
  for (let i = 0; i < vars.length; i += 1) {
    const pair = vars[i].split('=');
    if (decodeURIComponent(pair[0]) === key) {
      return decodeURIComponent(pair[1]);
    }
  }
};

const getDefaultState = () => {
  const day = getSearchParam('day');
  if (day) {
    return {
      selectedDates: [htmlDateParse(day).toISOString()],
      selectBy: 'day',
    };
  }
  const month = getSearchParam('month');
  if (month) {
    const parsedMonth = htmlMonthParse(month);
    return {
      selectedDates: timeDay.range(parsedMonth, timeMonth.offset(parsedMonth, 1)).map(d => d.toISOString()),
      selectBy: 'month',
    };
  }
  const year = getSearchParam('year');
  if (year) {
    const parsedYear = htmlYearParse(year);
    return {
      selectedDates: timeDay.range(parsedYear, timeYear.offset(parsedYear, 1)).map(d => d.toISOString()),
      selectBy: 'year',
    };
  }
  const now = new Date();
  return {
    selectedDates: timeDay.range(timeDay.offset(now, -14), now).map(d => d.toISOString()),
    selectBy: 'prev14',
  };
};

export const viewReducer = (state, action) => {
  if (action.type === loginAction.toString() || action.type === logoutAction.toString()) {
    // User changed, clean all data!
    return getDefaultState();
  }
  const result = {
    ...state,
    ...action.payload,
  };
  if (action.type === viewUpdatedAction.toString()) {
    delete result.modifier;
  }
  return result;
};

export default handleAction(combineActions(
  loginAction,
  logoutAction,
  selectActivityAction,
  setViewDatesAction,
  viewUpdatedAction,
), {
  next: viewReducer,
  throw: defaultErrorHandler,
}, getDefaultState());
